import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import {
  addLeaveTypeURL,
  allBusinessUnitURL,
  allDivisionURL,
  allEmployeeURL,
  allPayGradeURL,
  allPayLevelURL,
  allDepartmentURL,
  eligiblePercentPerPayURL,
  allLocationURL,
  allLegalEntitiesURL,
} from "../../../../Library/URLs";
// import { CircularProgress } from "@mui/material";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Multiselect from "multiselect-react-dropdown";
import SelectField from "../../../../Components/SelectField";
import { useParams } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    width: "552px",
    fontFamily: "Quicksand",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
    fontFamily: "Quicksand",
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2,fontFamily:'Quicksand, sans-serif' }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const CreateLeaveType = ({ open, handleClose, updateLeaveTypes }) => {
  const unique_id = uuid();
  const { companyid } = useParams();
  const { User } = useSelector((state) => state.payroll);
  const proxyEmployee = useSelector((state) => state.payroll.Proxy);
  const initState = {
    name: "",
    // min_day_duration: "",
    max_day_duration: "",
    leave_allowance: "",
    eligible_type_name: "",
    eligible_type_id: "",
    description: "",
  };
  const [formData, setFormData] = useState(initState);
  const [isLoading, setIsLoading] = useState(false);
  const [AllEmployee, setAllEmployee] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [EligibleAllowance, setEligibleAllowance] = useState([]);

  useEffect(() => {
    FetchAllBusinessUnit();
    FetchAllDivision();
    FetchAllDepartment();
    FetchAllGrade();
    FetchAllLevel();
    fetch();
    FetchAllLocation();
    FetchAllLegalEntities();
    FetchEligibleAllowance();
    // eslint-disable-next-line
  }, []);

  const [ParamOption, setParamOption] = useState("");
  const [AllDepartment, setAllDepartment] = useState("");
  const [SelectedDepartment, setSelectedDepartment] = useState("");

  const [AllDivision, setAllDivision] = useState("");

  const [AllBusinessUnit, setAllBusinessUnit] = useState();

  const [AllLocation, setAllLocation] = useState("");

  const [AllLegalEntities, setAllLegalEntities] = useState("");

  const [AllGrade, setAllGrade] = useState("");

  const [AllLevel, setAllLevel] = useState("");

  const [EmployeeID, setEmployeeID] = useState("");
  const [selectedValue, setValue] = useState("");
  const [SelectedEmployee, setSelectedEmployee] = useState([]);

  const [Group, setGroup] = useState("");

  const [FoundationObj, setFoundationObj] = useState("");

  const onSelect = (selectedList, selectedItem) => {
    // console.log('onSelected',selectedList,selectedItem)
    setSelectedEmployee(selectedList);
    // console.log('onSelected',SelectedEmployee)
    FilterEmployeeID(selectedList);
  };

  const FilterEmployeeID = (selectedList) => {
    const k = selectedList.map((item, index) => item.id);
    const Pipe = k.join("|");
    setEmployeeID(Pipe);
  };

  const onRemove = (selectedList, removedItem) => {
    //  console.log('onRemove',selectedList,removedItem)
    FilterEmployeeID(selectedList);
  };

  const FetchAllBusinessUnit = async () => {
    // console.log('all entity api')
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allBusinessUnitURL, data)
      .then((res) => {
        if (res.data.success === true) {
          const optionListing = res.data.data?.map((item) => {
            return { label: item.name, value: item.id };
          });
          setAllBusinessUnit(optionListing);
          // console.log('all Business unit',res.data.data)
        }
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };

  const FetchAllDivision = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allDivisionURL, data)
      .then((res) => {
        if (res.data.success === true) {
          const optionListing = res.data.data?.map((item) => {
            return { label: item.name, value: item.id };
          });
          setAllDivision(optionListing);
          // console.log('all division',res.data)
        }
        // console.log('all division result',res.data)
      })
      .catch((err) => {
        // console.log('Get all division error',err.message)
      });
  };

  const FetchAllDepartment = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allDepartmentURL, data)
      .then((res) => {
        if (res.data.success === true) {
          const optionListing = res.data.data?.map((item) => {
            return { label: item.name, value: item.id };
          });
          setAllDepartment(optionListing);
          // console.log('all depart',res.data)
        }
        // console.log('all department res',res.data)
      })
      .catch((err) => {
        // console.log('Get all department error',err.message)
      });
  };

  const FetchAllGrade = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allPayGradeURL, data)
      .then((res) => {
        const optionListing = res.data?.map((item) => {
          return { label: item.grade, value: item.id };
        });
        setAllGrade(optionListing);
      })
      .catch((err) => {
        // console.log('Get all pay grade error',err.message)
      });
  };

  const FetchAllLevel = async () => {
    // console.log('all entity api')
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allPayLevelURL, data)
      .then((res) => {
        const optionListing = res.data?.map((item) => {
          return { label: item.level, value: item.id };
        });
        setAllLevel(optionListing);
      })
      .catch((err) => {
        // console.log('Get all pay level error',err.message)
      });
  };

  const FetchAllLocation = async () => {
    // console.log('all entity api')
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allLocationURL, data)
      .then((res) => {
        const optionListing = res.data?.map((item) => {
          return { label: item.location, value: item.id };
        });
        setAllLocation(optionListing);
      })
      .catch((err) => {
        // console.log('Get all pay level error',err.message)
      });
  };

  const fetch = async () => {
    // console.log('all employee API is call')
    const raw = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allEmployeeURL, raw)
      .then((res) => {
        if (res.data.success === true) {
          setAllEmployee(res.data.data);
          const itemres = res.data.data?.map((item) => {
            return {
              ...item,
              full_name: `${item?.first_name} ${item?.middle_name} ${item?.last_name}`,
            };
          });
          setEmployeeOptions(itemres);
        }

        // console.log('length',res.data.employees.length)
      })
      .catch((err) => {
        // console.log('error'+err.message)
      });
  };

  const FetchEligibleAllowance = async () => {
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    // console.log('post data', data)
    await axios.post(eligiblePercentPerPayURL, data).then((res) => {
      if (res.data.success === true) {
        setEligibleAllowance(res.data.data);
        // toast.error(res.data.message)
      }
      console.log("all eligible percentage allowance item", res.data);
    });
  };

  const FetchAllLegalEntities = async () => {
    // console.log('all entity api')
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allLegalEntitiesURL, data)
      .then((res) => {
        if (res.data.success === true) {
          const optionListing = res.data.data?.map((item) => {
            return { label: item.name, value: item.id };
          });
          setAllLegalEntities(optionListing);
        }
      })
      .catch((err) => {
        // console.log('Get all pay level error',err.message)
      });
  };

  const createLeaveType = async () => {
    // console.log('all employee API is call')
    setIsLoading(true);
    const raw = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      proxy_id: proxyEmployee?.success?proxyEmployee?.id:null,
      ...formData,
      eligible_type_name:
        formData?.eligible_type_name !== "Specific Employee" &&
        formData?.eligible_type_name !== "All Employees"
          ? "Foundation Object"
          : formData.eligible_type_name,
      eligible_type_id:
        formData?.eligible_type_name === "Specific Employee"
          ? EmployeeID
          : FoundationObj?.value,
    };
    await axios
      .post(addLeaveTypeURL, raw)
      .then((res) => {
        setIsLoading(false);
        if (res.data.success === true) {
          toast.success(res.data?.data);
          setFormData(initState);
          handleClose();
          updateLeaveTypes();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log("error" + err.message);
        toast.error("Request Failed");
        setIsLoading(false);
      });
  };

  const closeDialog = () => {
    handleClose();
    setFormData(initState);
  };

  const dashboardTheme = window.localStorage.getItem("theme");

  const foundational_options =
    formData?.eligible_type_name === "Department"
      ? AllDepartment
      : formData?.eligible_type_name === "Business Unit"
      ? AllBusinessUnit
      : formData?.eligible_type_name === "Division"
      ? AllDivision
      : formData?.eligible_type_name === "Pay Grade"
      ? AllGrade
      : formData?.eligible_type_name === "Pay Level"
      ? AllLevel
      : formData?.eligible_type_name === "Location"
      ? AllLocation
      : formData?.eligible_type_name === "Legal Entity Country Specific"
      ? AllLegalEntities
      : [];

  const options = [
    {
      label: "All Employees",
      value: "All Employees",
    },
    {
      label: "Specific Employees",
      value: "Specific Employee",
    },
    {
      label: "Business Unit",
      value: "Business Unit",
      listItems: AllBusinessUnit,
    },
    {
      label: "Division",
      value: "Division",
      listItems: AllDivision,
    },
    {
      label: "Department",
      value: "Department",
      listItems: AllDepartment,
    },
    {
      label: "Pay Grade",
      value: "Pay Grade",
      listItems: AllGrade,
    },
    {
      label: "Pay Level",
      value: "Pay Level",
      listItems: AllLevel,
    },
    {
      label: "Legal Entity Country Specific",
      value: "Legal Entity Country Specific",
    },
    {
      label: "Location",
      value: "Location",
    },
  ];

  return (
    <BootstrapDialog
      onClose={closeDialog}
      aria-labelledby="customized-dialog-title"
      open={open}
      // maxWidth={'sm'}
      // fullWidth={true}
      className="Dialog_Wrap"
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={closeDialog}>
        <div className="Name">Create Absence Type</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="">
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Name</label>
              <input
                name="name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                type="text"
              />
            </div>
          </div>
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Description</label>
              <textarea
                name="description"
                value={formData.description}
                className="textarea"
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
                type="text"
                rows={3}
              ></textarea>
            </div>
          </div>
          <div className="Content_Wrap">
            {/* <div className="Box">
              <label htmlFor="">Min. Day Duration</label>
              <input
                name="min_day_duration"
                value={formData.min_day_duration}
                onChange={(e) =>
                  setFormData({ ...formData, min_day_duration: e.target.value })
                }
                type="text"
              />
            </div> */}
            <div className="Box">
              <label htmlFor="">Quota (Days)</label>
              <input
                name="max_day_duration"
                value={formData.max_day_duration}
                onChange={(e) =>
                  setFormData({ ...formData, max_day_duration: e.target.value })
                }
                type="text"
              />
            </div>
          </div>
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Leave Allowance</label>
              <select
                name="leave_allowance"
                value={formData.leave_allowance}
                onChange={(e) =>
                  setFormData({ ...formData, leave_allowance: e.target.value })
                }
              >
                <option value="" hidden>
                  Choose Leave Allowance
                </option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
          </div>
          <div className="Content_Wrap">
            <div className="Box">
              <label htmlFor="">Eligible Type Name</label>
              <select
                name="eligible_type_name"
                value={formData?.eligible_type_name}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    eligible_type_name: e.target.value,
                  })
                }
              >
                <option value="" hidden>
                  Choose Eligible Type
                </option>
                {options?.map((item) => (
                  <option key={item?.value} value={item?.value}>
                    {item?.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {formData.eligible_type_name === "Specific Employee" && (
            <div className="">
              <div className="Multi_Box">
                <label htmlFor="">Choose Employee</label>
                <Multiselect
                  showArrow={true}
                  closeOnSelect={true}
                  options={employeeOptions} // Options to display in the dropdown
                  selectedValues={selectedValue} // Preselected value to persist in dropdown
                  onSelect={onSelect} // Function will trigger on select event
                  onRemove={onRemove} // Function will trigger on remove event
                  displayValue="full_name" // Property name to display in the dropdown options
                  avoidHighlightFirstOption={true}
                  showCheckbox={true}
                />
              </div>
            </div>
          )}
          {formData.eligible_type_name !== "All Employees" &&
            formData.eligible_type_name !== "" &&
            formData.eligible_type_name !== "Specific Employee" && (
              <div className="Content_Wrap">
                <div className="Box">
                  <label htmlFor="">Choose {formData.eligible_type_name}</label>
                  <SelectField
                    name="foundational_obj"
                    onChange={(e) => setFoundationObj(e)}
                    options={foundational_options}
                    value={foundational_options?.find(
                      (item) => item?.value === formData?.employee_id
                    )}
                  />
                </div>
              </div>
            )}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Pay_Item_Btn_Action_Wrapper">
          <div className="Btn" onClick={handleClose}>
            Cancel
          </div>

          <div
            className="Btn"
            onClick={createLeaveType}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <span className="spinner-border spinner-grow-sm" />
            ) : (
              "Create"
            )}
          </div>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default CreateLeaveType;
